const RefundNote = () => {
    return (
        <p style={{ fontSize: "12px", color: "#7C7C7C" }}>
            If a product doesn’t meet your expectations, we’re happy to
            offer a refund for the product value. Please note, a 5% deduction
            will be made from the total invoice value to cover partial freight
            and packaging costs.
        </p>
    );
};

export default RefundNote;